(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["navigation-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super()
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      }
      this.querySelectorAll('a').forEach((item) =>
        item.addEventListener('click', this.onItemClick.bind(this))
      )
    }

    onItemClick(event) {
      event.preventDefault()
      const form = this.querySelector('form')
      this.elements.input.value = event.currentTarget.dataset.value
      if (form) form.submit()
    }
  }

  customElements.define('localization-form', LocalizationForm)

    document.addEventListener('DOMContentLoaded', function () {
    const newsletterForm = document.querySelector('#contact_form');

    if (!newsletterForm) return;

    newsletterForm.addEventListener('submit', function (event) {
      event.preventDefault();

      // Open Klaviyo form
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'V8x2fk']);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
